/* Thin wrappers around net.send for profile mutations. The server validates,
 * applies and echoes the new profile back – the UI never mutates local state. */
import { net } from './net';

export const equip = (slot: 'cardback' | 'felt' | 'frame' | 'title', id: string) =>
  net.send({ type: 'equip', slot, id });

export const equipSkin = (hero: string, skin: string) =>
  net.send({ type: 'equipSkin', hero, skin });

export const setFavoriteHero = (hero: string) =>
  net.send({ type: 'setFavoriteHero', hero });

export const setName = (name: string) =>
  net.send({ type: 'setName', name });

export const buyPremium = () => net.send({ type: 'buyPremium' });

export const redeemCode = (code: string) => net.send({ type: 'redeemCode', code });
